import styled, { css } from 'styled-components'

export default styled.p`
  ${({ theme, color }) => css`
    text-shadow: 3px 3px 0 ${color || 'white'};
  `}
`
